// A drag's map frames, held outside Redux and drawn by every output; the release commits once.
let held = null
const listeners = new Set()

export const heldMap = () => held

export const holdMap = data => {
	held = data
	for (const cb of listeners) cb()
}

/** Ends the hold and returns the last frame, or null. */
export const releaseMap = () => {
	const last = held
	held = null
	if (last) for (const cb of listeners) cb()
	return last
}

// The stage shapes a held frame draws: their fill nodes keep their last picture until the release, so a drag redraws outlines and never rebakes a field.
let heldShapes = new Set()

export const holdShapes = ids => {
	heldShapes = new Set(ids)
}

export const isShapeHeld = id => heldShapes.has(id)

export const subscribeHeldMap = cb => {
	listeners.add(cb)
	return () => listeners.delete(cb)
}
